import { ReactNode } from 'react';
import { Box, styled, Typography } from '@mui/material';

const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  gap: 24,
}));

const Item = styled('button')(() => ({
  all: 'unset',
  zIndex: 10,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: 'fit-content',
  transition: 'opacity 0.2s ease',
  gap: 2,

  '@media (any-hover: hover)': {
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

type Props = {
  controls: {
    id: string | number;
    icon: ReactNode;
    elementName: string;
    onClick: (element: string) => void;
    count?: string | number;
  }[];
};

export default function CollectionRightSide({ controls }: Props) {
  return (
    <Container>
      {controls.map(({ id, icon, onClick, count, elementName }) => (
        <Item key={id} onClick={() => onClick(elementName)}>
          {icon}
          {count && (
            <Typography
              fontSize={14}
              fontWeight={600}
              lineHeight="16px"
              color="white"
              sx={{ textShadow: '0px 1px 2px rgba(0, 0, 0, 0.5)' }}
            >
              {count}
            </Typography>
          )}
        </Item>
      ))}
    </Container>
  );
}
